import { sendShowPayLanding } from 'reactApp/modules/integration/communicator';
import { getIntegrationState } from 'reactApp/modules/integration/integration.selectors';
import type { IntegrationState } from 'reactApp/modules/integration/integration.types';
import { select } from 'redux-saga/effects';

export function* handleShowPayLanding() {
    const { parentOrigin }: IntegrationState = yield select(getIntegrationState);
    sendShowPayLanding(parentOrigin);
}
